/**
 * Component que renderitza el botó d'opcions (tres punts) per cada xat a la llista lateral.
 * Inclou el menú desplegable amb les accions de renombrar, preferit i eliminar.
 * 
 * @param {Object} props - Propietats de les accions.
 * @param {Object} props.chat - Dades del xat corresponent.
 * @param {string|null} props.openMenuId - ID del menú actualment obert.
 * @param {Function} props.setOpenMenuId - Canvia quin menú està obert.
 * @param {Set} props.favourites - Conjunt d'IDs de xats preferits.
 * @param {Function} props.toggleFavourite - Acció per alternar el preferit.
 * @param {Function} props.onRename - Acció de renombrar.
 * @param {Function} props.onDelete - Acció per eliminar.
 */
export default function ChatItemButtons({ chat, openMenuId, setOpenMenuId, favourites, toggleFavourite, onRename, onDelete }) {
  return (
    <>
      <button
        className="chat-menu-btn"
        onClick={e => { e.stopPropagation(); setOpenMenuId(openMenuId === chat.id ? null : chat.id); }}
        title="Opcions"
      >⋮</button>
      {openMenuId === chat.id && (
        <div className="chat-menu-dropdown" onClick={e => e.stopPropagation()}>
          <button className="chat-menu-item" onClick={() => { setOpenMenuId(null); onRename(chat); }}>
            <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
            Renombrar
          </button>
          <button className="chat-menu-item" onClick={() => { toggleFavourite(chat.id); setOpenMenuId(null); }}>
            <svg viewBox="0 0 24 24" width="13" height="13" fill={favourites.has(chat.id) ? '#f5c518' : 'none'} stroke={favourites.has(chat.id) ? '#f5c518' : 'currentColor'} strokeWidth="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            {favourites.has(chat.id) ? 'Treu preferit' : 'Preferit'}
          </button>
          <button className="chat-menu-item danger" onClick={() => { setOpenMenuId(null); onDelete(chat.id); }}>
            <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            Eliminar
          </button>
        </div>
      )}
    </>
  );
}
